export const MOBILE_LOGIN_GRADIENT =
  'linear-gradient(160deg, #19072d 0%, #3b1682 52%, #8b5cf6 100%)';

export const LOGIN_PURPLE = '#7c3aed';
export const LOGIN_PURPLE_HOVER = '#6d28d9';
export const LOGIN_PURPLE_SOFT = '#f3e8ff';
export const LOGIN_PURPLE_SOFT_HOVER = '#ede9fe';
export const LOGIN_PURPLE_BORDER = '#c4b5fd';
export const LOGIN_PURPLE_DISABLED = '#a78bfa';
export const LOGIN_PURPLE_FOCUS = 'rgba(124, 58, 237, 0.18)';
export const LOGIN_PURPLE_FOCUS_SOFT = 'rgba(124, 58, 237, 0.15)';
export const LOGIN_PURPLE_SHADOW = 'rgba(124, 58, 237, 0.22)';

export const LOGIN_PREMIUM_PANEL_BG =
  'linear-gradient(155deg, rgba(78, 31, 150, 0.92), rgba(27, 9, 57, 0.94))';
export const LOGIN_PREMIUM_PANEL_BORDER = '1px solid rgba(221, 214, 254, 0.24)';
export const LOGIN_PREMIUM_PANEL_SHADOW =
  '0 28px 78px rgba(17, 7, 45, 0.52), inset 0 1px 0 rgba(255,255,255,0.16)';
export const LOGIN_PREMIUM_INSET_BG =
  'linear-gradient(145deg, rgba(55, 20, 116, 0.86), rgba(20, 8, 43, 0.78))';
export const LOGIN_PREMIUM_WHITE_CARD =
  'linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(250,245,255,0.98) 100%)';
